import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Camera, Upload } from "lucide-react";

export default function PhotoRequest() {
  const [form, setForm] = useState({ name: "", phone: "", part_number: "", machine: "", message: "" });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [loading, setLoading] = useState(false);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onFile = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast.error("Emri dhe telefoni janë të detyrueshëm"); return; }
    setLoading(true);
    try {
      let image_url = "";
      if (file) {
        const fd = new FormData();
        fd.append("file", file);
        const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        image_url = r.data.url;
      }
      await api.post("/part-requests", { ...form, image_url });
      toast.success("Kërkesa u dërgua! Do t'ju kontaktojmë së shpejti.");
      setForm({ name: "", phone: "", part_number: "", machine: "", message: "" });
      setFile(null); setPreview("");
    } catch { toast.error("Gabim gjatë dërgimit"); }
    setLoading(false);
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6">
      <div className="hg-card overflow-hidden mb-6">
        <div className="relative h-40 sm:h-56 bg-[#131E30]">
          <img src="https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=1200" alt="" className="w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
            <div className="w-14 h-14 bg-[#FFD600] text-black flex items-center justify-center mb-3"><Camera size={26} /></div>
            <div className="font-display text-2xl sm:text-3xl uppercase">Nuk e di cilën pjesë të duhet?</div>
            <div className="text-sm text-neutral-300 mt-1">Dërgo fotografinë e pjesës ose etiketës dhe ne përpiqemi ta gjejmë.</div>
          </div>
        </div>
      </div>

      <form onSubmit={submit} className="hg-card p-5 space-y-4">
        <div>
          <label className="text-xs uppercase text-neutral-400 tracking-wider">Fotografia e pjesës</label>
          <label className="block mt-2 border-2 border-dashed border-[#1F2B44] hover:border-[#FFD600] cursor-pointer p-6 text-center transition-colors">
            {preview ? (
              <img src={preview} alt="preview" className="max-h-48 mx-auto" />
            ) : (
              <div className="flex flex-col items-center gap-2 text-neutral-400">
                <Upload size={28} /><span className="text-sm">Kliko për të ngarkuar një foto</span>
              </div>
            )}
            <input type="file" accept="image/*" onChange={onFile} data-testid="pr-file" className="hidden" />
          </label>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <label className="text-xs uppercase text-neutral-400">Emri *</label>
            <input required value={form.name} onChange={upd("name")} data-testid="pr-name" className="w-full bg-[#131E30] border border-[#1F2B44] px-3 py-2.5 mt-1" />
          </div>
          <div>
            <label className="text-xs uppercase text-neutral-400">Telefoni *</label>
            <input required value={form.phone} onChange={upd("phone")} data-testid="pr-phone" className="w-full bg-[#131E30] border border-[#1F2B44] px-3 py-2.5 mt-1" />
          </div>
          <div>
            <label className="text-xs uppercase text-neutral-400">Numri i pjesës</label>
            <input value={form.part_number} onChange={upd("part_number")} data-testid="pr-partnum" className="w-full bg-[#131E30] border border-[#1F2B44] px-3 py-2.5 mt-1" />
          </div>
          <div>
            <label className="text-xs uppercase text-neutral-400">Makineri / Model</label>
            <input value={form.machine} onChange={upd("machine")} data-testid="pr-machine" className="w-full bg-[#131E30] border border-[#1F2B44] px-3 py-2.5 mt-1" />
          </div>
        </div>
        <div>
          <label className="text-xs uppercase text-neutral-400">Shënim</label>
          <textarea rows={3} value={form.message} onChange={upd("message")} data-testid="pr-message" className="w-full bg-[#131E30] border border-[#1F2B44] px-3 py-2.5 mt-1" />
        </div>
        <button disabled={loading} data-testid="pr-submit" className="hg-btn-primary w-full py-4 uppercase font-bold text-sm disabled:opacity-40">
          {loading ? "Duke dërguar..." : "Dërgo Fotografinë"}
        </button>
      </form>
    </div>
  );
}
